/**
 * node:crypto shim for browser environment.
 * node-ical 0.25.6 uses require('node:crypto').randomUUID().
 * In browsers, crypto.randomUUID() is available on the global crypto object.
 */
export const randomUUID = (): string => {
  return globalThis.crypto.randomUUID()
}

export default {
  randomUUID,
}
